import { IconProps } from '@tamagui/helpers-icon';
import { RefreshCw } from '@tamagui/lucide-icons';
import { Rotate } from '@unistocks/components/animations/rotate';
import { Center } from '@unistocks/components/layout/center';
import { Paragraph } from '@unistocks/components/text/text';
import React from 'react';
import { ParagraphProps, ThemeableStackProps } from 'tamagui';

export type LoaderProps = ThemeableStackProps & {
  Icon?: React.ComponentType<IconProps>;
  color?: IconProps['color'];
  size?: IconProps['size'];
  textProps?: ParagraphProps;
  children?: string;
};

export const Loader: React.FC<LoaderProps> = ({
  Icon = RefreshCw,
  color = '$unistocks',
  size = '$6',
  children,
  textProps,
  ...props
}) => (
  <Center minH={'$20'} {...props}>
    <Rotate>
      <Icon color={color} size={size} />
    </Rotate>
    {children ? (
      <Paragraph size={'$7'} mt={'$3'} {...textProps}>
        {children}
      </Paragraph>
    ) : null}
  </Center>
);
